module.exports = __webpack_public_path__ + "media/images/sales/early/heading-faq-cf4a42eb3f8f5f2d3113a1dc321f6cab.svg";